import appConstants from '../constants/appConstants';
import { authPost } from '../utils/fecth-wrappers';

const API_BASE_URL = appConstants.API.icApiDealers;

/**
 * Serviço para validação de telefone via OTP
 */
export class PhoneVerificationService {
  /**
   * Valida o código OTP enviado pelo usuário
   * @param {string} userId - ID do usuário no MongoDB
   * @param {string} code - Código OTP de 6 dígitos
   * @returns {Promise<Object>} Resposta da API
   */
  static async verifyCode(userId, code) {
    try {
      const response = await authPost(`${API_BASE_URL}/profile/validate-phone`, {
        userId,
        code,
        isRetryCode: false,
      });

      return response;
    } catch (error) {
      console.error('Erro na verificação do código:', error);
      throw new Error(error.message || 'Código inválido');
    }
  }

  /**
   * Reenvia código OTP para validação de telefone
   * @param {string} userId - ID do usuário no MongoDB
   * @returns {Promise<Object>} Resposta da API
   */
  static async resendCode(userId, channel = 'whatsapp') {
    try {
      const response = await authPost(`${API_BASE_URL}/profile/validate-phone`, {
        userId,
        isRetryCode: true,
        // deliveryMethod informs backend whether to resend via whatsapp or call
        channel,
      });

      return response;
    } catch (error) {
      console.error('Erro ao reenviar código:', error);
      throw new Error(error.message || 'Erro ao reenviar código');
    }
  }
}
